import classNames from "classnames";
import React from "react";

import "./Tick.scss";

/*
 Specified sizes rather than allow to fill the parent due to the way 
 the bottom and the top of the tick scale together. I.e. we know the 
 component will definitely look good at these scales
 */
export const tickSizes = Object.freeze({
  XSMALL: "XSMALL",
  SMALL: "SMALL",
  MEDIUM: "MEDIUM",
  LARGE: "LARGE"
});

export const tickColors = Object.freeze({
  white: "white",
  malibu: "malibu",
  mariner: "mariner"
});

type Props = {
  animate?: boolean;
  checked?: boolean;
  color?: string;
  border?: number;
  borderRadius?: number;
  size?: keyof typeof tickSizes | string;
  className?: string;
  premiumTick?: boolean;
  roundedWrapper?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const Tick = ({
  checked,
  color,
  size = tickSizes.SMALL,
  animate,
  border,
  borderRadius,
  className,
  premiumTick,
  roundedWrapper,
  disabled,
  onClick
}: Props) => {
  const wrapperClass = classNames(className, {
    Tick__wrapper: true,
    "Tick__wrapper--checked": checked,
    "Tick__wrapper--malibu": color === tickColors.malibu,
    "Tick__wrapper--mariner": color === tickColors.mariner,
    "Tick__wrapper--white": color === tickColors.white,
    "Tick__wrapper--xsmall": size === tickSizes.XSMALL,
    "Tick__wrapper--small": size === tickSizes.SMALL,
    "Tick__wrapper--medium": size === tickSizes.MEDIUM,
    "Tick__wrapper--large": size === tickSizes.LARGE,
    "Tick__wrapper--premium": premiumTick,
    "Tick__wrapper--rounded": roundedWrapper
  });

  const tickClass = classNames({
    Tick__tick: true,
    "Tick__tick--malibu": color === tickColors.malibu,
    "Tick__tick--mariner": color === tickColors.mariner,
    "Tick__tick--white": color === tickColors.white,
    "Tick__tick--animate": animate,
    "Tick__tick--checked": checked,
    "Tick__tick--no-border": !border,
    "Tick_tick--premiumTick": premiumTick
  });

  const style: any = {};
  if (border) style.borderWidth = `${border}px`;
  if (borderRadius) style.borderRadius = `${borderRadius}px`;
  if (!disabled && onClick) style.cursor = "pointer";

  return (
    <div
      className={wrapperClass}
      style={style}
      onClick={() => !disabled && onClick && onClick()}
    >
      <span className={tickClass} />
    </div>
  );
};

export default Tick;
